


































































































































































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppAlertView from '@/components/AppAlertView.vue'
import AppConfirmModal from '@/components/AppConfirmModal.vue'
import AppRatingBar from '@/components/AppRatingBar.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import AppTwoColsCard from '@/components/AppTwoColsCard.vue'
import AppScrollToTop from '@/components/AppScrollToTop.vue'
import ItemFeeds from '@/components/ItemFeeds.vue'
import ItemHtml from '@/components/ItemHtml.vue'
import ItemRelatedFeeds from '@/components/ItemRelatedFeeds.vue'
import ItemRelatedItems from '@/components/ItemRelatedItems.vue'
import ItemReviewsCard from '@/components/ItemReviewsCard.vue'
import OptionModal from '@/components/OptionModal.vue'
import { ItemOption, ItemVariant, ItemOptionValue } from '@/interfaces'

import { logEvent, logAdnEvent, logWptgEvent } from '@/common'
import { analytics } from '@/firebase'
import { Item, ScrollToFetch } from '@/mixins'
import { CURRENT_USER } from '@/gql/auth'
import { FEED_TILE_FRAGMENT } from '@/gql/feed'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'
import { SHOW_LOGIN_MODAL } from '@/gql/misc'
import { CREATE_ORDER, ADD_SHOPPING_CART_ITEMS } from '@/gql/order'
import { MY_USER } from '@/gql/user'

@Component({
  components: {
    AppAlertView,
    AppConfirmModal,
    AppRatingBar,
    AppRouterLink,
    AppTwoColsCard,
    AppScrollToTop,
    ItemFeeds,
    ItemHtml,
    ItemRelatedFeeds,
    ItemRelatedItems,
    ItemReviewsCard,
    OptionModal
  },
  metaInfo () {
    const _this = this as any
    const brandName = _this.item.seller ? _this.brandName(_this.item) : ''
    const content = `${brandName} ${_this.item.name}${_this.discountRate ? ' ' + _this.discountRate + '%' : ''} ${_this.formatNumber(_this.item.price)}원`
    return {
      meta: [
        { name: 'description', content },
        { property: 'og:description', content },
        { property: 'og:title', content: `${_this.item.name} - 페퍼로니` },
        { property: 'og:image', content: _this.item.medias.length && _this.imgSrcResized(_this.item.medias[0].path, '800') },
        { property: 'og:url', content: location.origin + location.pathname },
        { property: 'product:price:amount', content: _this.item.price },
        { property: 'product:price:currency', content: 'KRW' },
        { property: 'product:productId', content: _this.item.id }
      ]
    }
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    myUser: {
      query: MY_USER,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    },
    orderAskCount: {
      query: gql`query orderAskCount($itemId: ID!) {
        orderAskCount(filter: { itemId: $itemId })
      }`,
      variables () { return { itemId: this.$route.params.id } }
    },
    itemReviewCount: {
      query: gql`query ($itemId: ID!) {
        itemReviewCount(filter: { itemId: $itemId })
      }`,
      variables () { return { itemId: this.$route.params.id } }
    },
    itemReviewRate: {
      query: gql`query ($itemId: ID!) {
        itemReviewRate(filter: { itemId: $itemId })
      }`,
      variables () { return { itemId: this.$route.params.id } }
    },
    item: {
      query: gql`query item($itemId: ID!) {
        item(itemId: $itemId) {
          id
          isActive
          display
          name
          price
          orgPrice
          detailHtml
          isLiked
          likeCount
          soldOut
          usingPepperService
          maxCommissionRate
          optionType
          paybackEnabled
          brand {
            id
            name
          }
          medias {
            id
            path
          }
          seller {
            id
            username
            shop {
              id
              status
              shoppingMallName
              deliveryFee
              minForFreeDelivery
            }
            media {
              id
              path
            }
          }
          options {
              id
              name
              values {
                  id
                  text
              }
              required
          }
          variants {
              id
              code
              additionalAmount
              display
              selling
              soldOut
              optionValues {
                  optionId
                  optionValueId
                  optionName
                  optionValue
              }
          }
        }
      }`,
      variables () {
        return {
          itemId: this.$route.params.id
        }
      },
      manual: true,
      async result ({ data }) {
        const changed = data.item.id !== this.item.id
        this.item = data.item
        if (changed) {
          this.addedItemVariants = []
          if (!data.item.isActive || !data.item.display || data.item.seller.shop.status !== 'ACTIVE') {
            await this.routerReplace('/not-found')
          }
          document.title = `${data.item.name} - 페퍼로니`
          await logEvent('select_content', { item_id: data.item.id, content_type: 'item' })
          if (analytics) {
            await this.logAppsflyerEvent('af_content_view', {
              af_price: data.item.price,
              af_content_id: data.item.id,
              af_content_type: 'item',
              af_currency: 'KRW'
            })
            window.fbq('track', 'ViewContent', {
              value: data.item.price,
              currency: 'KRW',
              content_type: 'product',
              content_ids: data.item.id
            })
            // window.ne_tgm_q.push({
            //   tagType: 'detail',
            //   device: 'web',
            //   uniqValue: '',
            //   pageEncoding: 'utf-8',
            //   items: [{
            //     id: data.item.id /* ID값입력 */,
            //     price: data.item.price /* 가격정보입력 */,
            //     quantity: '1' /* 갯수정보입력 */,
            //     category: '' /* 카테고리 대|중|소 */,
            //     imgUrl: data.item.medias[0].path /* img링크값입력 ex)http://example.com/img/img.jpg */,
            //     name: '' /* 제품명또는 전환메뉴명입력 */,
            //     desc: '' /* 상품상세 설명 text */,
            //     link: '' /* 상품상세페이지 URL ex)http://example.com/detail/product.html */
            //   }]
            // })
            logAdnEvent({ ut: 'Item', items: [{ i: this.item.id }] })
            logWptgEvent({ ty: 'Item', items: [{ i: this.item.id, t: this.item.name }] })
          }
        }
      }
    },
    itemReviewedFeedConnection: {
      query () {
        return gql`query itemReviewedFeedConnection($itemId: Int!) {
          itemReviewedFeedConnection(itemId: $itemId, first: 10000000) {
            cursor
            hasNextPage
            feeds {
              ...FeedTileFragment
            }
          }
        }
        ${FEED_TILE_FRAGMENT}`
      },
      variables () {
        return {
          itemId: +this.$route.params.id
        }
      }
    },
    itemRelatedItemConnection: {
      query () {
        return gql`query itemRelatedItemConnection($itemId: Int!, $after: String) {
          itemRelatedItemConnection(itemId: $itemId, after: $after) {
            cursor
            hasNextPage
            items {
              ...ItemTileFragment
            }
          }
        }
        ${ITEM_TILE_FRAGMENT}`
      },
      variables () {
        return {
          itemId: +this.$route.params.id
        }
      }
    }
    /*
    itemRelatedFeedConnection: {
      query () {
        return gql`query itemRelatedFeedConnection($itemId: Int!, $after: String) {
          itemRelatedFeedConnection(itemId: $itemId, after: $after) {
            cursor
            hasNextPage
            feeds {
              ...FeedTileFragment
            }
          }
        }
        ${FEED_TILE_FRAGMENT}`
      },
      variables () {
        return {
          itemId: +this.$route.params.id
        }
      }
    },
    */
  }
})
export default class extends Mixins(Item, ScrollToFetch) {
  currentUser: { id: string } | null = null
  myUser = { albaType: '' }
  item: {
    id: string;
    name: string;
    orgPrice: number;
    price: number;
    isLiked: boolean;
    soldOut: boolean;
    usingPepperService: boolean;
    likeCount: number;
    options: ItemOption[];
    variants: ItemVariant[];
    medias: { path: string }[];
    seller?: {
      shop: {
        deliveryFee: number;
        minForFreeDelivery: number;
      };
    };
  } = {
    id: '',
    name: '',
    orgPrice: 0,
    price: 0,
    isLiked: false,
    soldOut: false,
    usingPepperService: false,
    likeCount: 0,
    options: [],
    variants: [],
    medias: []
  }

  isOptionModalActive = false
  availableItemOptions: ItemOptionValue[] = []
  itemReviewedFeedConnection: {
    feeds: {}[];
  } = {
    feeds: []
  }

  itemRelatedItemConnection: {
    items: {}[];
  } = {
    items: []
  }

  /*
  itemRelatedFeedConnection: {
    cursor: string|null;
    hasNextPage: boolean;
    feeds: {}[];
  } = {
    cursor: null,
    hasNextPage: false,
    feeds: []
  }
  */

  addedItemVariants: {
    name: string;
    variantId: string;
    quantity: number;
    additionalAmount: number;
  }[] = []

  imageNumber = '-'
  isAlertViewEnabled = false
  isPepperItemInfoModalActive = false
  isPaybackInfoModalActive = false

  async mounted () {
    this.addScrollListener('itemRelatedItemConnection', 'items')
    if (this.$route.query.fromFeedId) {
      await this.$apollo.mutate({
        mutation: gql`mutation ($input: UserFeedReactionInput!) {
          sendUserFeedReaction(input: $input) {
            id
          }
        }`,
        variables: {
          input: {
            feedId: this.$route.query.fromFeedId,
            retentions: 1,
            openItem: false,
            openContents: false,
            playedAt: 0,
            reactedItemId: -1,
            reactedFeedId: -1
          }
        }
      })
    }
  }

  async onClickShare () {
    await this.shareLocation(`item-${this.$route.params.id}`)
  }

  get discountRate () {
    if (!this.item.orgPrice) return undefined
    return Math.round((this.item.orgPrice - this.item.price) * 100 / this.item.orgPrice)
  }

  get shopDeliveryFeeText () {
    if (!this.item.seller) {
      return ''
    }
    if (this.item.seller.shop.deliveryFee > 0) {
      if (this.item.seller.shop.minForFreeDelivery > 0) {
        return `${this.formatNumber(this.item.seller.shop.deliveryFee)}원 (${this.formatNumber(this.item.seller.shop.minForFreeDelivery)}원 이상 구매 시 무료)`
      } else {
        return `${this.formatNumber(this.item.seller.shop.deliveryFee)}원`
      }
    } else {
      return '무료 배송'
    }
  }

  get showPepperUI () {
    return this.myUser.albaType === 'PEPPER' && this.item.usingPepperService
  }

  async onClickLikeItem () {
    await this.toggleLikeItem(this.item.id, this.item.isLiked)
  }

  async onActionAlertView (index: number) {
    this.isAlertViewEnabled = false

    if (index === 0) {
      await this.createOrder()
    } else if (index === 1) {
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
    }
  }

  async clickBuyItem () {
    if (this.item.soldOut) return

    this.availableItemOptions = []
    if (this.item.options.length === 0) {
      this.availableItemOptions.push({
        variant: this.item.variants.length > 0 ? this.item.variants[0] : undefined,
        nextOptionValues: []
      })
    } else {
      this.availableItemOptions.push(...this.buildAvailableItemOptions(0, this.item.options, this.item.variants))
    }
    this.isOptionModalActive = true
  }

  buildAvailableItemOptions (optionIndex: number, options: ItemOption[], variants: ItemVariant[]): ItemOptionValue[] {
    const option = options[optionIndex]

    if (optionIndex === options.length - 1) {
      return variants
        .map(variant => ({ variant, optionValue: variant.optionValues.find(optionValue => optionValue.optionId === option.id) }))
        .map(({ variant, optionValue }: { variant: ItemVariant; optionValue: ItemOptionValue|undefined }) => {
          if (optionValue === undefined || !variant.display || variant.soldOut) {
            return undefined
          }
          return {
            optionId: option.id,
            optionName: option.name,
            optionValueId: optionValue.optionValueId,
            optionValue: optionValue.optionValue,
            variant,
            nextOptionValues: []
          }
        }).reduce((acc: ItemOptionValue[], cur) => {
          if (cur) acc.push(cur)
          return acc
        }, [])
    } else {
      return option.values.map(optionValue => {
        const variantsHasOption = variants.filter(variant =>
          variant.optionValues.find(variantOptionValue =>
            variantOptionValue.optionId === option.id && variantOptionValue.optionValueId === optionValue.id) && variant.display)

        const nextOptionValues = this.buildAvailableItemOptions(optionIndex + 1, options, variantsHasOption)
        if (nextOptionValues.length === 0) {
          return undefined
        }
        return {
          optionId: option.id,
          optionName: option.name,
          optionValueId: optionValue.id,
          optionValue: optionValue.text,
          variant: undefined,
          nextOptionValues: nextOptionValues
        }
      }).reduce((acc: ItemOptionValue[], cur) => {
        if (cur) acc.push(cur)
        return acc
      }, [])
    }
  }

  increaseItemQuantity (index: number) {
    this.$set(this.addedItemVariants[index], 'quantity', this.addedItemVariants[index].quantity + 1)
  }

  decreaseItemQuantity (index: number) {
    if (this.addedItemVariants[index].quantity > 1) {
      this.$set(this.addedItemVariants[index], 'quantity', this.addedItemVariants[index].quantity - 1)
    }
  }

  removeItemVariant (index: number) {
    this.addedItemVariants.splice(index, 1)
  }

  get addedItemVariantsTotalAmount () {
    return this.addedItemVariants.reduce((total, cur) => total + (cur.additionalAmount + this.item.price) * cur.quantity, 0)
  }

  async logAddToCart () {
    await logEvent('add_to_cart', {
      currency: 'KRW',
      items: this.addedItemVariants.map(variant => ({
        price: this.item.price + variant.additionalAmount,
        item_id: this.item.id,
        item_name: this.item.name,
        quantity: variant.quantity
      }))
    })
    if (analytics) {
      await this.logAppsflyerEvent('af_add_to_cart', {
        af_price: this.addedItemVariants.map(addedItemVariant => this.item.price + addedItemVariant.additionalAmount),
        af_content_id: Array(this.addedItemVariants.length).fill(this.item.id),
        af_currency: 'KRW',
        af_quantity: this.addedItemVariants.map(addedItemVariant => addedItemVariant.quantity)
      })
      window.fbq('track', 'AddToCart', {
        value: this.addedItemVariants.reduce((acc, cur) => {
          acc += this.item.price + cur.additionalAmount
          return acc
        }, 0),
        currency: 'KRW',
        content_type: 'product',
        content_ids: this.item.id
      })
      // window.ne_tgm_q.push({
      //   tagType: 'cart',
      //   device: 'web',
      //   uniqValue: '',
      //   pageEncoding: 'utf-8',
      //   items: this.addedItemVariants.map(variant => ({
      //     id: this.item.id /* ID값입력 */,
      //     price: this.item.price + variant.additionalAmount /* 가격정보입력 */,
      //     quantity: variant.quantity /* 갯수정보입력 */,
      //     category: '' /* 카테고리 대|중|소 */,
      //     imgUrl: this.item.medias[0].path /* img링크값입력 ex)http://example.com/img/img.jpg */,
      //     name: '' /* 제품명또는 전환메뉴명입력 */,
      //     desc: '' /* 상품상세 설명 text */,
      //     link: '' /* 상품상세페이지 URL ex)http://example.com/detail/product.html */
      //   }))
      // })
      logAdnEvent({
        ut: 'Cart',
        items: this.addedItemVariants.map(variant => ({
          i: this.item.id,
          c: '',
          s: this.item.name,
          q: variant.quantity,
          p: (this.item.price + variant.additionalAmount) * variant.quantity
        }))
      })
      logWptgEvent({
        ty: 'Cart',
        items: this.addedItemVariants.map(() => ({
          i: this.item.id,
          t: this.item.name
        }))
      })
    }
  }

  async onCreateOrder () {
    if (!this.currentUser) {
      this.isAlertViewEnabled = true
    } else {
      await this.createOrder()
    }
  }

  async createOrder () {
    if (this.addedItemVariants.length === 0) {
      alert('옵션을 선택하여 주세요.')
      return
    }

    await this.showLoading()
    try {
      const { data } = await this.$apollo.mutate({
        mutation: CREATE_ORDER,
        variables: {
          input: {
            orderItemInputs: this.addedItemVariants.map(addedItemVariant => ({
              itemId: this.item.id,
              itemVariantId: addedItemVariant.variantId,
              quantity: addedItemVariant.quantity,
              fromFeedId: this.$route.query.fromFeedId
            }))
          }
        }
      })
      if (data.createOrder.success) {
        await this.logAddToCart()
        if (analytics) {
          await this.logAppsflyerEvent('af_initiated_checkout', {
            af_price: this.addedItemVariantsTotalAmount,
            af_content_id: this.item.id,
            af_currency: 'KRW',
            af_quantity: this.addedItemVariants.reduce((acc, cur) => acc + cur.quantity, 0)
          })
        }

        await this.routerPush(`/orders/${data.createOrder.orderForm.id}/created`)
      } else {
        await this.showToast(data.createOrder.message)
      }
    } finally {
      await this.dismissLoading()
    }
  }

  async addShoppingCartItems () {
    if (this.addedItemVariants.length === 0) {
      alert('옵션을 선택하여 주세요.')
      return
    }

    const { data } = await this.$apollo.mutate({
      mutation: ADD_SHOPPING_CART_ITEMS,
      variables: {
        input: {
          orderItemInputs: this.addedItemVariants.map(addedItemVariant => ({
            itemId: this.item.id,
            itemVariantId: addedItemVariant.variantId,
            quantity: addedItemVariant.quantity,
            fromFeedId: this.$route.query.fromFeedId
          }))
        }
      }
    })
    this.evictApolloCache('getShoppingCart')
    await this.showToast(data.addShoppingCartItems.message)
    await this.logAddToCart()
    this.addedItemVariants = []
  }

  visibilityChanged (isVisible: boolean, index: number) {
    if (!isVisible) return
    this.imageNumber = `${index + 1}`
  }
}
